"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocationPicker_1 = require("./LocationPicker");
(function (w, $) {
    if (!$)
        return false;
    var locationPickerExtensions = {
        locationPicker: function () {
            return this.each(function () {
                var obj = $(this);
                new LocationPicker_1.LocationPicker(obj);
            });
        }
    };
    $.fn.extend(locationPickerExtensions);
})(window, $);
